import { fetchAuthSession } from "aws-amplify/auth";

class _ApiClient {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  async getEntryForDate(date, signal) {
    const token = (await fetchAuthSession()).tokens.idToken.toString();

    return fetch(
      `${this.baseUrl}/journal-entries/entry/${date.getFullYear()}/${
        date.getMonth() + 1
      }/${date.getDate()}`,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        signal,
      },
    );
  }

  async submitEntry(entries, signal) {
    const token = (await fetchAuthSession()).tokens.idToken.toString();

    return fetch(`${this.baseUrl}/journal-entries`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(entries),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      signal,
    });
  }

  async updateEntryById(entryId, entries, signal) {
    const token = (await fetchAuthSession()).tokens.idToken.toString();

    return fetch(`${this.baseUrl}/journal-entries/${entryId}/entries`, {
      method: "PATCH",
      credentials: "include",
      body: JSON.stringify(entries),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      signal,
    });
  }

  async getEntriesForMonth(date, signal) {
    const token = (await fetchAuthSession()).tokens.idToken.toString();

    // Note +1 on month because month is zero indexed, note lack of GET "method" because this is by default.
    return fetch(
      `${
        this.baseUrl
      }/journal-entries/entry_dates_by_month/${date.getFullYear()}/${
        date.getMonth() + 1
      }`,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        signal,
      },
    );
  }
}

const ApiClient = new _ApiClient(
  process.env.REACT_APP_API_URL ?? "http://localhost:8080/api",
);

export default ApiClient;
